<!--  -->
<template>
  <div>
    <section class="course-area course-area4">
    <div class="course-wrapperer">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                  <div class="course-tab-wrap d-flex align-items-center">
                     <img src="/static/images/icon_zbcc.png" class="courses-showing-icon"/><span class="courses-showing-text">共有{{intTotal}}场直播课程</span>
                    </div><!-- end course-tab-wrap -->
                    
                </div><!-- end col-lg-12 -->
            </div><!-- end row -->
            <div class="row courses-search">
                <div class="col-lg-4">
                     <div class="course-filter d-flex align-items-center ml-auto">
                            <div class="courses-ordering">
                                <h3 class="widget__title">课程科目</h3>
                                <el-select v-model="searchType" placeholder="所有科目">
                                    <el-option
                                    v-for="courcate in courcates"
                                    :key="courcate.name"
                                    :label="courcate.name"
                                    :value="courcate.name">
                                    </el-option>
                                </el-select>
                            </div><!-- end courses-ordering -->
                        </div><!-- end course-filter -->
                </div>
                 <div class="col-lg-4">
                     <div class="sidebar-widget">
                            <h3 class="widget__title">搜索课程</h3>
                            <div class="contact-form-action">
                                <el-input
                                    placeholder="搜索课程"
                                    v-model="searchWords">
                                    <i slot="suffix" class="el-icon-search" @click="toPage(1)"></i>
                                </el-input>
                            </div><!-- end contact-form-action -->
                        </div><!-- end sidebar-widget -->
                </div>
                 <div class="col-lg-4">
                    <div class="sidebar-widget level-widget">
                            <h3 class="widget__title">讲师</h3>
                             <el-select v-model="searchAuthor" placeholder="所有讲师">
                                <el-option
                                v-for="author in authors"
                                :key="author.title"
                                :label="author.title"
                                :value="author.title">
                                </el-option>
                            </el-select>
                        </div><!-- end sidebar-widget -->
                </div>
            </div>
        </div><!-- end container -->
    </div><!-- end course-wrapper -->
    <div class="course-content-wrapper">
        <div class="container">
            <div class="row course-item-wrap">
                <div class="col-lg-12">
                    <div class="tab-content">
                        <div role="tabpanel" class="tab-pane fade show active" id="tab1">
                            <div class="row course-block">
                                <div class="col-lg-3" v-for="(live,index) in lives" :key="index">
                               <div class="category-item">
                                  <img :src="live.picsrc?`${global.remoteIp}/uploads/${live.picsrc}`:'/static/images/mor.jpg'" alt="">
                                  <div class="course-tooltip">
                                    <span class="tooltip-label">{{dateFormat(new Date(live.time),"yyyy-MM-dd hh:mm")}}</span>
                                  </div>
                                  <div class="category-content">
                                      <span class="cat__title"><router-link :to="`/mylive/${live._id}`">{{live.title}}</router-link></span>
                                      <span class="cat__meta_right"><router-link :to="`/mylive/${live._id}`" class="read-more" style="live.state=='1'?'color: #62C485;':''">{{live.state=='1'?'已开播':'未开播'}}</router-link></span>
                                  </div>
                                  <div class="category-content" style="    margin-top: 10px;">
                                      <span class="cat__teacher"><router-link :to="`/mylive/${live._id}`">{{live.teacher}}</router-link></span>
                                  </div>
                                  <div class="category-content" style="text-align: center;">
                                      <span class="cat__time"><router-link :to="`/mylive/${live._id}`">直播开始时间： {{dateFormat(new Date(live.time),"yyyy-MM-dd  hh:mm")}}</router-link></span>
                                  </div>
                              </div>
                                </div><!-- end col-lg-6 -->
                            </div><!-- end course-block -->
                        </div><!-- end tab-pane -->
                    </div><!-- end tab-content -->
                    <div class="pagination-wrap">
                        <nav aria-label="Page navigation">
                            <el-pagination
                            background
                            :page-size="6"
                            :hide-on-single-page="intTotal<=6"
                            layout="prev, pager, next"
                            @current-change="toPage"
                            @prev-click="toPage"
                            @next-click="toPage"
                            :total="intTotal">
                        </el-pagination>
                        </nav>
                    </div><!-- end pagination-wrap -->
                </div><!-- end col-lg-8 -->
            </div><!-- end row -->
        </div><!-- end container -->
    </div><!-- end course-content-wrapper -->
</section><!-- end courses-area -->
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  data() {
    return {
      courcates: [],
      lives: [],
      global,
      searchType: "",
      searchWords: "",
      intTotal: 20,
      intCurrent: 1,
      searchAuthor: [],
      plateid: "",
      authors: [],
      searchStars: "",
      searchPrice: [],
      sortType: "",
      searchLevel: [],
    };
  },
  props: {
    plates: Array,
  },
  components: {},

  computed: {},

  mounted() {
    this.$axios.get("/api/courseTypes?sort=-createdAt").then((res) => {
      if (res.data) {
        this.courcates = res.data.data;
      }
    });
    this.$axios
      .get("/api/livings?page=1&limit=6&sort=-createdAt")
      .then((res) => {
        if (res.data) {
          this.lives = res.data.data;
          this.intTotal = res.data.total;
        }
      });
    for (var i = 0; i < this.plates.length; i++) {
      if (this.plates[i].name == "名师简介") {
        this.plateid = this.plates[i]._id;
      }
    }
    this.$axios
      .get(`/api/articles?plateid=${this.plateid}&limit=6&sort=-createdAt`)
      .then((res) => {
        if (res.data) {
          this.authors = res.data.data;
        }
      });
  },
  watch: {
    searchAuthor() {
      this.toPage(1);
    },
    searchType() {
      this.toPage(1);
    },
    searchWords() {
      this.toPage(1);
    },
    searchStars() {
      this.toPage(1);
    },
    searchPrice() {
      this.toPage(1);
    },
    sortType() {
      this.toPage(1);
    },
    searchLevel() {
      this.toPage(1);
    },
  },
  methods: {
    toTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    toPage(intcount) {
      if (intcount) this.intCurrent = intcount;
      var searchConditions = "";
      if (this.searchType) {
        searchConditions += "&type=" + this.searchType;
      }
      if (this.searchWords) {
        searchConditions += "&title=$regex:" + this.searchWords;
      }
      if (this.searchAuthor && this.searchAuthor.length > 0) {
        searchConditions += "&author[in]=" + this.searchAuthor;
      }
      if (this.searchLevel && this.searchLevel.length > 0) {
        searchConditions += "&level[in]=" + this.searchLevel;
      }
      if (this.searchStars) {
        searchConditions += "&stars=" + this.searchStars;
      }
      if (this.sortType) {
        searchConditions += "&sort=" + this.sortType;
      } else {
        searchConditions += "&sort=state";
      }
      if (this.searchPrice == "0") {
        searchConditions += "&price=0";
      } else {
        searchConditions += "&price[ne]=0";
      }
      this.$axios
        .get(
          `/api/livings?page=${
            this.intCurrent
          }&limit=6${searchConditions}`
        )
        .then((res) => {
          if (res.data) {
            this.intTotal = res.data.total;
            this.lives = res.data.data;
       //     this.toTop();
          }
        });
    },
     dateFormat(date, format) {
      var o = {
        "M+": date.getMonth() + 1, //month
        "d+": date.getDate(), //day
        "h+": date.getHours(), //hour 24
        "H+": date.getHours(), //hour 24
        "m+": date.getMinutes(), //minute
        "s+": date.getSeconds(), //second
        "q+": Math.floor((date.getMonth() + 3) / 3), //quarter
        S: date.getMilliseconds(), //millisecond
      };

      if (/(y+)/.test(format)) {
        format = format.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }

      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
        }
      }
      return format;
    },
  },
};
</script>
<style scoped>

/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #51be78;
}
/deep/ .el-pager li.active {
  color: #51be78;
}
/deep/ .el-input__inner{
	height: 61px;
    line-height: 61px;
    width:368.8px;
    margin-top:15px;
    font-size: 16px;
}
/deep/ .el-input__suffix{
     margin-top:15px;
     height: 61px;
   
}
/deep/ .el-select .el-input .el-select__caret{
  color: #4282CAFF;
    font-size: 23px;
    font-weight: 600;
}
.el-icon-search{
        line-height: 61px;
    font-size: 21px;
    margin-right: 10px;
}
/deep/ .el-radio{
    margin-right: 41px;
    margin-left: 27px;
}
/deep/ .el-radio__label{
    font-size:16px;
    /* font-weight: 600; */
}
/deep/ .el-radio__inner{
        border: 2px solid #4485CCFF;
}

.course-wrapperer{
	width: 1198px;
	height: 216px;
	background: #ffffff66;
	box-shadow: 0px 6px 17px 1px rgba(68, 133, 204, 0.27);
	border-radius: 5px;
	margin: auto;
	padding: 15px;
}

a:not([href]):not([tabindex]) {
    color: initial !important;
}

.category-item{
/* width: 294px;
height: 212px; */
width: 288px;
padding: 0px;
border: 1px solid #EEEEEE;
border-radius: 5px;
height:328.9px;
}
.category-item img{
width: 100%;
height: 212px;
border-radius: 5px;
}
.course-tooltip {
    /* height: 25px; */
       position: absolute;
         top: 188px;
    right: 10px;
    background: #0000006b;
    border-radius: 10px 0px 0px 0px;
    height: 25px;
    padding: 2px;
    line-height:20px;
    
}
.tooltip-label{
  font-size: 12px;
    color: #FFFFFF;
}
.cat__title {
  width: 200  px;
height: 16px;
font-size: 16px;
font-weight: 600;
color: #313F57;
text-align: left;
}
.cat__teacher{
height: 14px;
font-size: 14px;
font-family: PingFang SC;
font-weight: 500;
color: #737D85;
}
.cat__teacher a{
  color: #737D85;
}

.cat__time{
height: 14px;
font-size: 14px;
font-family: PingFang SC;
font-weight: 500;
color: #737D85;
text-align: center;
}
.cat__time a{
  color: #737D85;
}
.cat__title a{
  color: #313F57;
}

.category-content{
  margin-top: 17px;
  padding-right: 4px;
  padding-left: 7px;
  font-size: 16px;
}
.cat__meta_right{
      float: right;
      line-height:23px;
      width: auto;
}
.cat__meta_right a{
  color: #313F57;
      width: 41px;
    height: 14px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #F68A03;
   
}
.col-lg-3{
  padding-left: 10px;
  padding-right:10px;
}
.course-area {
    /* height: 796px; */
    margin-top: 31px;
    line-height: 20px;
}
</style>
